import { Component, OnInit } from '@angular/core';
import { TypeDeSorts } from 'src/app/_enums/typeDeSort';
import { Competence } from 'src/app/_models/competence';
import { Sort } from 'src/app/_models/sort';
import { AdminService } from 'src/app/_services/admin.service';
import { CompetenceService } from 'src/app/_services/competence.service';
import { SortService } from 'src/app/_services/sort.service';

@Component({
  selector: 'app-admin',
  templateUrl: './sorts.component.html',
  styleUrls: ['./sorts.component.scss']
})
export class AdminSortsComponent implements OnInit {
  constructor(private adminService: AdminService, private sortService: SortService) {}

  sorts!: Sort[];
  public typeDeSorts = new TypeDeSorts;

  ngOnInit(): void {
    this.sortService.getSorts()          
    .subscribe({
      next: (sorts) => this.sorts = sorts.sort((a,b) => a.nom.localeCompare(b.nom)),
    });
  }

  public getType(s: Sort): string {
    return this.typeDeSorts.values.get(s.type) || "";
  }
}
